import { Controller } from "@hotwired/stimulus";
import qrcode from "qrcode-generator";

export default class extends Controller {
  static targets = ["image"];

  static values = { provisioningUri: String };

  connect() {
    const code = qrcode(0, "M");
    code.addData(this.provisioningUriValue);
    code.make();
    this.imageTarget.src = code.createDataURL(6, 0);
  }
}
